import { Switch, SwitchProps } from 'antd';
import React, { FC } from 'react';

export const ILSSwitch: FC<SwitchProps> = (props) => {
  return <Switch {...props} />;
};
